import { getPayloadData, getIsApiPending } from '../../../selectors/biasharaFlexi/payloadCollection';
import { setExpiredAuth } from '../../../actions/biasharaFlexi/quote';
import {
    apiTransitionOrderConfirmation,
    confirmOrderSuccess,
    confirmOrderFailure,
} from '../../../actions/biasharaFlexi/payment';
import { getAccessToken, getIsConfirmOrderAPiPending } from '../../../selectors/biasharaFlexi/payment';
import axios from 'axios';
import { getCompanyIdValue } from '../../../selectors/biasharaFlexi/companyDetails';

export const orderConfirmationService = (store, next, action) => {
    (async () => {
        if (!getIsConfirmOrderAPiPending(store.getState())) {
            store.dispatch(apiTransitionOrderConfirmation.pending());
            try {
                const resp = await confirmInsuranceOrder(store.getState());
                store.dispatch(confirmOrderSuccess(resp.data));
                store.dispatch(apiTransitionOrderConfirmation.success());
            } catch (e) {
                if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
                    store.dispatch(setExpiredAuth(true));
                }
                store.dispatch(apiTransitionOrderConfirmation.failure());
                store.dispatch(confirmOrderFailure(e));
            }
        }
    })();
    return next(action);
};

const confirmOrderPayload = (state) => {
    const payloadData = getPayloadData(state);
    // const id = payloadData?.companyDetails?.id;
    const cid = getCompanyIdValue(state);
    const payload = {
        id: cid.value,
    };

    // Change payload here
    return {
        ...payload,
    };
};

const confirmInsuranceOrder = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/biashara-flexi/order/confirmation';
        const response = await axios.post(url, confirmOrderPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
        return response;
    } catch (e) {
        if (e?.response?.data?.status === 401 || e?.response?.data?.status === 403) {
            store.dispatch(setExpiredAuth(true));
        }
        throw e;
    }
};
